/**
 * InputStream
 *
 * @author Kazuhiko Arase
 */
export class InputStream {
    constructor() { }
    close() { }
}
//# sourceMappingURL=InputStream.js.map